import React, { forwardRef } from "react";
import { SectionCard, RangeBtn, RANGES, C } from "../shared";

const OhlcvSection = forwardRef(({ chartData, activeRange, setActiveRange }, ref) => (
  <SectionCard
    ref={ref} id="ohlcv" icon="ohlcv" title="Recent OHLCV Data" noPad
    right={
      <div style={{ display: "flex", gap: 6, padding: "0 14px 0 0" }}>
        {RANGES.slice(0, 3).map(r => (
          <RangeBtn key={r.label} label={r.label} active={activeRange.label === r.label} onClick={() => setActiveRange(r)} />
        ))}
      </div>
    }
  >
    <div style={{ overflowX: "auto" }}>
      <table className="tdash-table" style={{ minWidth: 560 }}>
        <thead>
          <tr>
            {["Date", "Open", "High", "Low", "Close", "Volume", "Prev Close"].map(h => (
              <th key={h} style={{ textAlign: h === "Date" ? "left" : "right" }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {[...chartData].reverse().slice(0, 15).map((row, i) => {
            const up = row.ldcp != null ? row.close >= row.ldcp : true;
            return (
              <tr key={row.date + i}>
                <td style={{ color: C.body, fontWeight: 500, whiteSpace: "nowrap" }}>{row.date}</td>
                {[row.open, row.high, row.low].map((v, j) => (
                  <td key={j} style={{ textAlign: "right", color: C.muted }}>{v?.toFixed(2) ?? "—"}</td>
                ))}
                <td style={{ textAlign: "right", fontWeight: 700, color: up ? C.green : C.red }}>{row.close?.toFixed(2) ?? "—"}</td>
                <td style={{ textAlign: "right", color: C.muted }}>{row.volume?.toLocaleString() ?? "—"}</td>
                <td style={{ textAlign: "right", color: C.faint }}>{row.ldcp?.toFixed(2) ?? "—"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </SectionCard>
));

export default OhlcvSection;
